import { render, staticRenderFns } from "./AddEditAddressView.vue?vue&type=template&id=051b8e5d&"
import script from "./AddEditAddressView.vue?vue&type=script&lang=js&"
export * from "./AddEditAddressView.vue?vue&type=script&lang=js&"
import style0 from "./AddEditAddressView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports